import _slicedToArray from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import _ from 'lodash';
import { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LottieLoading from "../../../LottieLoading";
import { StyledPipe, StyledTab } from "../../../Tabs";
import { BestBuyStatus, useUserBestBuyList } from "../../../../hooks";
import { useModalSwitch, useRefreshToken } from "../../../../state/application/hooks";
import { ApplicationModal } from "../../../../state/application/reducer";
import EmptyOrder from "./EmptyOrder";
import Order from "./Order";
import OrderDetail from "../OrderDetail";
import { OrderTabs, StyledOrderList, StyledOrderListWrapper } from "./styled";
var OrderStatusTab;

(function (OrderStatusTab) {
  OrderStatusTab["OPEN"] = "open";
  OrderStatusTab["HISTORY"] = "history";
})(OrderStatusTab || (OrderStatusTab = {}));

var OpenOrderStatuses = [BestBuyStatus.Pending, BestBuyStatus.PartialFilled];
var HistoryOrderStatuses = [BestBuyStatus.Fulfilled, BestBuyStatus.Cancelled, BestBuyStatus.Expired, BestBuyStatus.PartialFillExpired];

var OrderList = () => {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var refreshToken = useRefreshToken();

  var _useState = useState(OrderStatusTab.OPEN),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var _useState2 = useState(),
      selectedOrder = _useState2[0],
      setSelectedOrder = _useState2[1];

  var tabARef = useRef();
  var tabBRef = useRef();
  var observerRef = useRef(null);

  var _useUserBestBuyList = useUserBestBuyList(activeTab === OrderStatusTab.OPEN ? OpenOrderStatuses : HistoryOrderStatuses),
      data = _useUserBestBuyList.data,
      hasNextPage = _useUserBestBuyList.hasNextPage,
      size = _useUserBestBuyList.size,
      setSize = _useUserBestBuyList.setSize,
      error = _useUserBestBuyList.error;

  var switchOrderDetailModal = useModalSwitch(ApplicationModal.BEST_BUY_ORDER_DETAIL);

  var handleOpenOrderDetail = order => {
    var _order$trades;

    var trades = (_order$trades = order.trades) !== null && _order$trades !== void 0 ? _order$trades : [];
    if (trades.length === 0) return;
    setSelectedOrder(order);
    switchOrderDetailModal(true);
  };

  useEffect(() => {
    setSize(1);
  }, [refreshToken]);
  useEffect(() => {
    var observer = new IntersectionObserver(_ref => {
      var _ref2 = _slicedToArray(_ref, 1),
          entry = _ref2[0];

      if (entry.isIntersecting && hasNextPage) {
        setSize(size + 1);
      }
    }, {
      threshold: 1
    });

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => {
      if (observerRef.current) {
        observer.unobserve(observerRef.current);
      }
    };
  }, [observerRef.current, hasNextPage, data === null || data === void 0 ? void 0 : data.length]);
  var isLoading = !data && !error;
  var isEmpty = (data === null || data === void 0 ? void 0 : data.length) === 0 || error;
  return __jsx(StyledOrderListWrapper, null, __jsx(OrderTabs, null, __jsx(StyledTab, {
    ref: tabARef,
    active: activeTab === OrderStatusTab.OPEN,
    onClick: () => {
      setActiveTab(OrderStatusTab.OPEN);
    }
  }, t('open_orders')), __jsx(StyledPipe, null), __jsx(StyledTab, {
    ref: tabARef,
    active: activeTab === OrderStatusTab.HISTORY,
    onClick: () => {
      setActiveTab(OrderStatusTab.HISTORY);
    }
  }, t('order_history'))), isEmpty && __jsx(EmptyOrder, null), isLoading && __jsx(LottieLoading, {
    boxProps: {
      my: '50px'
    }
  }), !isEmpty && !isLoading && __jsx(StyledOrderList, null, _.orderBy(data, ['createdAt'], 'desc').map(order => __jsx(Order, {
    key: order === null || order === void 0 ? void 0 : order.id,
    order: order,
    handleOpenOrderDetail: handleOpenOrderDetail
  })), __jsx("div", {
    ref: observerRef,
    style: {
      height: '1px'
    }
  })), selectedOrder && __jsx(OrderDetail, {
    order: selectedOrder
  }));
};

export default OrderList;